<template>
  <div :class="$style.container">
    <header>
      <span>提示</span>
      <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="$emit('close')"></i>
    </header>
    <main v-if="type == 0">
      <p>当前游戏版本过低，请<span>联系客服</span>处理</p>
      <div :class="$style.btnGroup">
        <button @click="concat">联系客服</button>
      </div>
    </main>
    <main v-if="type == 1">
      <p>您当前的游戏版本过低</p>
      <p>需下载最新版本才可使用云挂机功能</p>
      <div :class="$style.btnGroup">
        <button @click="$emit('close')">暂时不需要</button>
        <button @click="submit">下载最新版本</button>
      </div>
    </main>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { gameOpenDownloads } from '@/bridge/AppJsBridge';
import { getCloudApkDownloadUrl } from '@/api/suspend';
import { isPure } from '@/libs/utils';

export default {
  data() {
    return {
      type: -1,
      boxDownLoadShow: false,
      download_url: ''
    };
  },
  mounted() {
    this.getUrl()
  },
  computed: {
    ...mapState({
      cloud_hang_up_box_url: (state) => state.suspend.cloud_hang_up_box_url,
      cloud_hang_up_template_id: (state) => state.suspend.cloud_hang_up_template_id,
      cloud_hang_up_template_name: (state) => state.suspend.cloud_hang_up_template_name,
    }),
  },
  methods: {
    async submit() {
      gameOpenDownloads({
        gameUrl: this.download_url,
      });
    },
    async getUrl() {
      const appkey = this.$getStorage('appkey');
      const r = await getCloudApkDownloadUrl({ appkey });
      this.type = r.content.status;
      this.download_url = r.content.download_url;
      if (!isPure()) {
        this.type = 0;
      }
    },
    concat() {
      const tabs = this.$store.state.suspend.tabs;
      this.$store.commit('suspend/CHANGE_STATE', { 
        sideBarVisible: false,
        activeTab: tabs.find(item => item.type == 'kefu') 
      });
    }
  },
  components: {
  },
};
</script>
<style module lang="scss">
.container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 260px;
  height: 160px;
  background: #ffffff;
  border-radius: 5px;
  > header {
    color: #ffffff;
    width: 260px;
    height: 30px;
    background: #ff5b58;
    border-radius: 5px 5px 0px 0px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .fanhui {
      position: absolute;
      right: 10px;
      font-size: 14px;
    }
  }
  > main {
    padding-top: 30px;
    > p {
      font-size: 12px;
      line-height: 16px;
      font-weight: bold;
      text-align: center;
      > span {  
        color: #ff5b58;
        font-weight: bold;
      }
    }
    .btnGroup {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 5px;
      > button {
        display: block;
        border: none;
        outline: none;
        padding: 8px 18px;
        background: #ff5b58;
        border-radius: 14px;
        font-size: 12px;
        text-align: center;
        color: #ffffff;
        margin:15px 10px 5px;
        &:active {
          opacity: 0.7;
        }
      }
    }
    .redirect {
      color: #ff5b58;
      font-size: 10px;
      position: absolute;
      bottom: 0;
      right: 5px;
    }
  }
}
</style>
